<template>
  <v-dialog
    v-model="dialog"
    scrollable
    :fullscreen="fullscreen"
    :overlay="false"
    transition="dialog-top-transition"
  >
    <v-card>
      <v-toolbar
        color="primary lighten-1"
        dark
      >
        <v-card-title primary-title color="info">
          <v-icon class="mr-4">mdi-folder-marker</v-icon>
          {{locationGroup ? locationGroup.name : ""}}
        </v-card-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="fullscreen = ! fullscreen">
            <v-icon>{{fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen'}}</v-icon>
        </v-btn>
        <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-toolbar color="warning" v-if="(! isProcessed) && locationGroup" dense flat>
        <strong>Processing in progress</strong>: {{locationGroup.processing_stage}}
        <v-spacer></v-spacer>
        {{formatDate(new Date(locationGroup.updated_at))}}
      </v-toolbar>
      <v-card-text>
      <v-card elevation="0" class="my-2"  v-if="isProcessed">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" x-large :href="locationGroup.download_url">
            <v-icon class="mx-4">mdi-download</v-icon>
            Download Full Dataset
          </v-btn>
        </v-card-actions>

        </v-card>
        <v-row>
          <v-col :cols="numCols">
            <!--### MAIN MAP ###-->
            <div v-if="isProcessed" >
              <location-map :location-group="locationGroup"></location-map>
              <drive-time-button-group v-on:drive-time-changed="fetchData"></drive-time-button-group>
              <v-row v-if="properties">
                <v-col>
                  <property-detail-table :items="properties"/>
                </v-col>
              </v-row>

            </div>
            <div v-else-if="dialog">
              <v-data-table
                :headers="headers"
                :items="locations"
                item-key="id"
                :loading="loading"
                style="width:auto;"
              >
              </v-data-table>
            </div>

          </v-col>
          <v-col v-if="is2Col" cols="6">
            <property-details />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import { formatDate } from '@/utils/format'
import LocationMap from './LocationMap.vue'
import { handleLocationData } from '@/utils/map.js'
import PropertyDetailTable from '@/components/PropertyDetailTable.vue'
import DriveTimeButtonGroup from '@/components/DriveTimeButtonGroup.vue'
import PropertyDetails from '@/components/PropertyDetails.vue'

export default {
  components: { LocationMap, PropertyDetailTable, DriveTimeButtonGroup, PropertyDetails },
    data() {
    return {
      dialog: false,
      fullscreen: false,
      locations: [],
      headers: [
        {text: "Weight/Amount", value: "weight"},
        {text: "Name", value: "name"},
        {text: "Address", value: "address"},
        {text: "State", value: "state"},
        {text: "Zip", value: "zip"},
        {text: "Stories", value: "stories"},
        {text: "Latitude", value: "lat"},
        {text: "Longitude", value: "lon"}
      ]
    }
  },
  props: {
      shown: {
        type: Boolean,
        default: false
      },
      locationGroup: {
        type: Object,
        default: null
      }
  },
  computed: {
    is2Col: function() {
      return (this.selectedProperty != null)
    },
    numCols: function() {
      return (this.selectedProperty != null) ? 6 : 12
    },
    isProcessed: function() {
      return Boolean(this.locationGroup && this.locationGroup.processed_at !== null)
    },
    ...mapState({
      loading: 'loading',
      drive_time: state => state.drive_time,
      properties: state => state.propertyData,
      selectedProperty: (state) => state.selectedProperty,
      propertyRscores: state => state.propertyRscores
    })
  },
  methods: {
    fetchData: function() {
      if (this.locationGroup && this.locationGroup.id)
        this.$store.dispatch('updateState', ['selectedProperty', null]).then(() => {
        this.$store.dispatch('updateState', ['mapPoints', null])
        this.$store.dispatch('updateState', ['propertyData', null])
      }).then(() => {
        this.$axios.get(process.env.VUE_APP_API_HOST + `/custom_location_groups/${this.locationGroup.id}/locations`, {
          params: {
            drive_time: this.drive_time
          }
        }).then(response => {
          this.locations = response.data
          handleLocationData(response.data, this.$store)
        })

      })
    },
    formatDate: function(date, localeOptions = null, hideTime = false) {
      return formatDate(date, localeOptions, hideTime)
    },

  },
  watch: {
      shown: {
          immediate: true,
          handler(newVal, oldVal) {
              this.dialog = newVal;
          }
      },
      locationGroup: {
          immediate: true,
          handler(newVal, oldVal) {
            this.fetchData()
          }
      },
      dialog: function(newVal) {
          if (! newVal) {
              this.$emit('close-dialog');
          }
      }
  }
}
</script>
